module.exports = __webpack_public_path__ + "img/leftBack.fdc195d7.svg";